// extracted by mini-css-extract-plugin
module.exports = {"miniCapsuleDetail":"MiniCapsuleDetail_miniCapsuleDetail__3jzci"};